// extracted by mini-css-extract-plugin
export default {"container":"page-body_container__r+Ldk","seperator":"page-body_seperator__rReSO"};